export const defaultAsyncFn = async () => {}
